"use strict";

exports.removeLeadingAndTrailingHTTPWhitespace = function (string) {
  return string.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "");
};

exports.removeTrailingHTTPWhitespace = function (string) {
  return string.replace(/[\t\n\r ]+$/, "");
};

exports.isHTTPWhitespaceChar = function (char) {
  return char === " " || char === "\t" || char === "\n" || char === "\r";
};

exports.solelyContainsHTTPTokenCodePoints = function (string) {
  return /^[!#-'\*\+\x2D\.0-9A-Z\^-z\|~]*$/.test(string);
};

exports.soleyContainsHTTPQuotedStringTokenCodePoints = function (string) {
  return /^[\t -~\x80-\xFF]*$/.test(string);
};

exports.asciiLowercase = function (string) {
  return string.replace(/[A-Z]/g, function (l) {
    return l.toLowerCase();
  });
}; // This variant only implements it with the extract-value flag set.


exports.collectAnHTTPQuotedString = function (input, position) {
  var value = "";
  position++;

  while (true) {
    while (position < input.length && input[position] !== "\"" && input[position] !== "\\") {
      value += input[position];
      ++position;
    }

    if (position >= input.length) {
      break;
    }

    var quoteOrBackslash = input[position];
    ++position;

    if (quoteOrBackslash === "\\") {
      if (position >= input.length) {
        value += "\\";
        break;
      }

      value += input[position];
      ++position;
    } else {
      break;
    }
  }

  return [value, position];
};